<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Fine Detailed Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center" class="no-display">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0f2027" rounded dense required v-model="org" :items="org_list" item-text="name" return-object label="Organization" outlined @click="clear()" @change="getAy()"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" outlined persistent-hint
                        hint="Please Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
                        item-value="standard" label="Standard" outlined @change="
              getStandard();
              clear();
            " persistent-hint hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col sm="2" v-if="std != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="div" :items="dision_list" item-text="div_name"
                        item-value="div_off_id" label="Division" outlined @change="clear()"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" @change="clear()"
                        :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint
                        hint="Select Status" />
                </v-col>
            </v-row>
            <v-row dense justify="center" class="no-display">
                <v-col sm="8" md="8" cols="12">
                    From Date (Inclusive) ::
                    <input id="datePickerId" type="date" v-model="fromdate" @click="show = false" />

                    To Date (Exclusive) ::
                    <input id="datePickerId" type="date" v-model="todate" @click="show = false" />
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-0 pt-0" v-if="fromdate && todate" @click="getAllReport()"
                        :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info != ''" class="">
                <!-- <v-col sm="2">
                    <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                </v-col> -->
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" rounded color="success" outlined @click="
                fnExcelReport('my-table-id', 'installmentoutstandingreport')
              " :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                            Hide /Show Logo
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printReport()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>

                    <!-- search code shiv -->
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field class="ma-2 no-display" v-model="search" append-icon="mdi-magnify"
                            label="Search by Student name or by Registration Number" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <!-- header code -->
                        <v-simple-table></v-simple-table>
                        <div v-if="org_basic_data">
                            <v-row dense justify="center">
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo"
                                    align="center">
                                    <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                                </v-col>
                                <v-col cols="12" sm="4" md="8">
                                    <center>
                                        <!-- <h2>
                                            <strong>{{ org_basic_data.trust_name }}</strong>
                                        </h2> -->
                                        <h2>
                                            <strong>{{ org_name }} </strong>
                                        </h2>
                                        <center>
                                            <b> <span>Fine Detailed Report {{this.current_academic_year.ay}} </span></b>
                                        </center>
                                        <!-- <span>{{ org_basic_data.address }}</span> <br />
                                        <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                        <span>Email :{{ org_basic_data.email }} </span> <br />
                                        <span>Website :{{ org_basic_data.website }} </span> -->
                                        <!-- <br /> -->
                                    </center>
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                                    <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                </v-col>
                            </v-row>
                        </div>
                        <!-- <div>
                            <center>
                                <b> <span>Fine Detailed Report </span></b>
                            </center>
                        </div> -->
                        <!-- header end -->
                        <v-row dense justify="center">
                            <v-col sm="4" md="4">
                                <v-autocomplete class="pt-2" clearable rounded outlined dense v-model="search_today"
                                    :items="learner_info" item-text="section" label="Search Section" persistent-hint
                                    single-line></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-simple-table dense class="elevation-1" fixed-header>
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Mobile No.</th>
                                    <!-- <th class="">Quota</th>
                                    <th class="">Academic Year</th> -->
                                    <th class="">Admission Year</th>
                                    <th class="">Standard</th>
                                    <th class="">Section</th>
                                    <th class="">Division</th>
                                    <th class="">Fine</th>
                                    <th class="">Receipt No.</th>
                                    <th class="">Date</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="s in filteredLearnerInfo" :key="s.id">
                                    <!-- <tr v-for="s in filteredItems" :key="s.id"> -->
                                    <td>{{ s.sr_no }}</td>
                                    <td>{{ s.reg_no }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.primary_contact_number }}</td>
                                    <!-- <td>{{ s.quota }}</td>
                                    <td>{{ s.academicyear }}</td> -->
                                    <td>{{ s.learner_addmission_year }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.section }}</td>
                                    <td>{{ s.div }}</td>
                                    <td>{{ s.fine }}</td>
                                    <td>
                                        <v-tooltip top color="warning">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn class="mt-1 mb-1" outlined rounded small color="warning"
                                                    v-bind="attrs" v-on="on" @click="
                                                    print(
                                                        s.receipt_no,
                                                        s.ay,
                                                        s.reg_no
                                                    )
                                                    ">
                                                    <v-icon color="warning">mdi-printer</v-icon>
                                                    {{ s.receipt_no }}
                                                </v-btn>
                                            </template>
                                            <span> Print Fee Receipt!!! </span>
                                        </v-tooltip>
                                        <!-- {{ s.receipt_no }} -->
                                    </td>
                                    <td>{{ s.date }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                loader: false,
                extraBreadcrumbItems: [
                 

                ],
                org_list: null,
                org: "",
                breadcrumbClass: "breadcrumb-style1",
                color: "",
                snackbar: false,
                search: "",
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                div: null,
                std: "",
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: null,
                stream_list: null,
                header_list: null,
                show: false,
                learner_info: [],
                fromdate: null,
                todate: null,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
                org_basic_data: [],
                show_logo: true,
                learner_info:[],
                org_id: null,
                org_name:null,
                search_today:null,
            };
        },
        computed: {
            filteredLearnerInfo() {
                if (!this.search) 
                return this.learner_info;
                return this.learner_info.filter(learner => {
                    const searchItem = this.search.toLowerCase();
                    return (
                        learner.name.toLowerCase().includes(searchItem) ||
                        learner.reg_no.toLowerCase().includes(searchItem)
                    );
                });
            },
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const filename = name+'.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            showLogo() {
                if (this.show_logo) {
                    this.show_logo = false;
                } else {
                    this.show_logo = true;
                }
            },
            print(receipt_no, ay, registration_number) {
                //alert(receipt_no)
                //alert(ay)
                //alert(registration_number)
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                if (this.org_id == "zeal") {
                    let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "wws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-wws",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "uwws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-uwws",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "sanjivani") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-sanjivani",
                    });
                    window.open(routeData.href, "_blank");
                }
                 else {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts" });
                    window.open(routeData.href, "_blank");
                }
            },
            printReport() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            ExportToExcel() {
                var htmltable = document.getElementById("my-table-id");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
            },
            clear() {
                this.learner_info = [];
                this.data_list = [];
            },
            getAllReport() {
                this.loader = true;
                this.search = "";
                const data = {
                    ay: this.current_academic_year.ay,
                    std: this.std,
                    div: this.div,
                    status: this.status,
                    fromdate:this.fromdate,
                    todate:this.todate,
                    org:this.org.id
                };
                axios
        .post("/InstallmentStructureDetails/getFineDetailedReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_info = res.data.learner_info;
            this.org_basic_data = res.data.org_basic_data
            this.loader= false
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong");
          this.loader = false;
        })
        .finally(() => {
          this.show_copy_dialog = true;
        });
               
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg_without_all")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
             getAy() {
      this.academic_year_list = null,
      this.standard_list = null,
      this.ay = null
      this.std_id = null,
      this.div = null
      this.dision_list = null
      const data = {
        org: this.org.id,
      };
      axios
        .post("/Management/getAy", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.academic_year_list;
            //this.dision_list = res.data.div_list
            this.standard_list = res.data.standard_list
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
     getStandard() {
      const data = {
        ay: this.current_academic_year.ay,
        std: this.std,
        org: this.org.id,
      };
      axios
        .post("/Management/getDiv", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.dision_list = res.data.dision_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
        },
        mounted() {
            this.onload();
            this.org_id = localStorage.getItem("EPS-tenant");
            this.org_name = localStorage.getItem("EPS-org-name");
        },
    };
</script>
<style scoped>
input[type="date"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    /* .scroll {
  overflow-x: scroll;
} */
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    .dt-button {
        font-size: small;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }

    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        img {
            width: 100% !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        /* .stud-table {
    overflow-x: hidden !important;
  } */
        .box {
            background-color: white !important;
            /* margin: 8px !important;
    padding: 8px; */
            border: none !important;
            /* overflow: hidden !important; */
        }
        /* tr,
  td,
  th {
    font-size: large !important;
  } */

        @page {
            size: A4;
            margin-top: none !important;
            padding-top: none;
            /* size: 16in 17in; */
            size: 20in 17in;
        }
    }
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 86%;
    }
</style>
